export default "__VITE_ASSET__031d0e9c__"